import axiosInstance from "./setup-api.js"; //currently just axios
import TokenService from "../services/token-service.js";
import {useAuthStore} from "@/stores/auth"; // Import Pinia store
import {useRouter} from "vue-router";
import type {Router} from "vue-router";

const NO_REFRESH_PATHS = [
    "/api/auth/login", // if user is not confirmed I got 401 and did not come from refresh
    "/api/auth/register",
    "/api/auth/refresh"
];
/**
 * interceptors catch any results and/or errors even before the promises are execute resp. then/error calls.
 */
const setupInterceptors = (router: Router) => {
    const authStore = useAuthStore();
    //console.warn("setupInterceptors", authStore);

    axiosInstance.interceptors.request.use(
        (config) => {

            /**
             const token = localStorage.getItem("user-token");
             if (token) {
             axiosInstance.defaults.headers.common["Authorization"] = token;
             }
             */
                // TODO this is needed - in api common will be set, but here the config is returned
                //TODO improve check with other solution in auth, user api and setup interceptor
            const token = TokenService.getLocalAccessToken();
            //console.warn("loaded token by interceptor", token);
            if (token) {
                // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
                config.headers["Authorization"] = token; // for Node.js Express back-end
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (res) => {
            console.log("axiosInstance.interceptors.response use");
            return res;
        },
        async (error) => {
            //Logger.error("api interceptor: response error invalid", err.config.url);
            const originalConfig = error.config;

            // last call was an api call (and i.e. not refresh and the first time)
            if (
                error.response?.status === 401 &&
                !NO_REFRESH_PATHS.includes(originalConfig.url) &&
                !originalConfig._retry
            ) {
                // set retry so same call is not done more than once
                originalConfig._retry = true;

                try {
                    // TODO change
                    const postData = {
                        email: TokenService.getLocalUser().email,
                        refreshToken: TokenService.getLocalRefreshToken()
                    };
                    //Logger.debug("api interceptor: response postData", postData);

                    const result = await authStore.refresh(postData)
                    //Logger.debug("api interceptor: result", result);
                    // this means the api with the original config is excuted again after token is refreshed.
                    return axiosInstance(originalConfig);


                    /*
                    const rs = await axiosInstance.post("/api/auth/refresh", postData);
                    const { accessToken } = rs.data;
                    useAuthStore.dispatch('auth/refreshToken', accessToken);
                    TokenService.updateLocalAccessToken(accessToken);
                    */

                } catch (_error) {
                    return Promise.reject(_error);
                }
            } else {
                // if refresh was not successful and returns an error
                // TODO check which error codes we need to involve to route to login 404 is for authToken not found in db
                if (
                    originalConfig.url === "/api/auth/refresh" &&
                    (error.response?.status === 401 || error.response?.status === 404)
                ) {
                    authStore.logout().then(() => {
                        //window.location.replace('/#/login');
                        router.push("/login")
                    });
                }
            }
            return Promise.reject(error);
        }
    );
};

export default setupInterceptors;
